import Post from "../post/Post";
import "./posts.css";

export default function Posts({ posts }) {
  return (
    <div className="posts">
      {posts.map((p, idx) => (
        <Post key={"l" + idx} post={p} />
      ))}
    </div>
  );
}
